import { mqMin, space, tok } from '@sunwebgroup/ui-components'
import { CountryFlagGlyph } from '@sunwebgroup/ui-components/src/uds/components/IconCountryFlag/IconCountryFlag'
import { Typography } from '@sunwebgroup/ui-components/uds'
import { IconCountryFlag } from '@sunwebgroup/ui-components/uds/index'
import { styled } from 'styled-components'

interface ReviewerInfoProps {
  flagCode?: CountryFlagGlyph
  reviewerName?: string
  partyCompositionLabel?: string
  isBigWrapper?: boolean
}

const Wrapper = styled.div`
  gap: ${space('primitives_space_12')};
  align-items: center;
  display: flex;
`
const ReviewerName = styled(Typography)`
  ${Typography.modVariant('body-m-bold-tight')};
`

const ReviewerType = styled(Typography)`
  ${Typography.modVariant('body-m-regular-tight')};
  color: ${tok('semantics_content_secondary_color')};
`
const LabelWrapper = styled.div<{ $isBigWrapper?: boolean }>`
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ${ReviewerName},
  ${ReviewerType} {
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media ${mqMin('primitives_breakpoint_m_min')} {
    gap: ${space('primitives_space_6')};
    
  ${({ $isBigWrapper }) => $isBigWrapper && `
    flex-direction: row;

    ${ReviewerName},
    ${ReviewerType} {
      width: unset;
    }
  `}
`

export default function ReviewerInfo({ flagCode, reviewerName, partyCompositionLabel, isBigWrapper }: ReviewerInfoProps) {
  return (
    <Wrapper>
      {flagCode && <IconCountryFlag glyph={flagCode} size={18} />}
      <LabelWrapper $isBigWrapper={isBigWrapper}>
        {reviewerName && <ReviewerName>{reviewerName}</ReviewerName>}
        {partyCompositionLabel && <ReviewerType>{partyCompositionLabel}</ReviewerType>}
      </LabelWrapper>
    </Wrapper>
  )
}
